"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// from npm package react-material-snackbar which would not build
var SnackBar = function SnackBar(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSnackBar = _useState2[0],
      setShowSnackBar = _useState2[1];

  var _useState3 = (0, _react.useState)(60),
      _useState4 = _slicedToArray(_useState3, 2),
      localHeight = _useState4[0],
      setLocalHeight = _useState4[1];

  var show = props.show,
      delay = props.delay,
      onHideSnackbar = props.onHideSnackbar;
  var el = (0, _react.useRef)(null);
  var hideSnackbar = (0, _react.useCallback)(function () {
    setShowSnackBar(false);
    onHideSnackbar();
  }, [onHideSnackbar]);

  var setHeight = function setHeight() {
    if (el && el.clientHeight && localHeight !== el.clientHeight) {
      setLocalHeight(el.clientHeight);
    }
  };

  (0, _react.useEffect)(function () {
    setShowSnackBar(show);
    var timer = delay && show ? setTimeout(hideSnackbar, delay) : null;
    return function () {
      return clearTimeout(timer);
    };
  }, [delay, hideSnackbar, show]);
  var bsStyle = props.bsStyle;
  var icon;

  switch (bsStyle) {
    case 'info':
      icon = 'fa-info-circle';
      break;

    case 'success':
      icon = 'fa-check';
      break;

    case 'warning':
    case 'danger':
      icon = 'fa-exclamation-triangle';
      break;

    default:
      icon = 'fa-info-circle';
  }

  var snackbarStyle = {
    position: 'fixed',
    left: 0,
    right: 0,
    top: "-".concat(localHeight + 30, "px"),
    transitionTimingFunction: 'ease-in-out',
    transition: '300ms',
    transform: showSnackBar ? "translateY(".concat(localHeight + 50, "px)") : 'translateY(0px)',
    zIndex: '2000',
    visibility: showSnackBar ? 'visible' : 'hidden'
  };
  setHeight();
  return _react["default"].createElement("div", {
    className: "snackbar snackbar-".concat(bsStyle),
    style: snackbarStyle
  }, _react["default"].createElement("div", {
    className: "snackbar-icon"
  }, _react["default"].createElement("i", {
    className: "fa ".concat(icon)
  })), _react["default"].createElement("div", {
    className: "snackbar-text"
  }, props.children), _react["default"].createElement("button", {
    type: "button",
    className: "close",
    "aria-hidden": "true",
    onClick: hideSnackbar
  }, "\xD7"));
};

SnackBar.defaultProps = {
  bsStyle: 'success',
  show: false
};
SnackBar.propTypes = {
  bsStyle: _propTypes["default"].oneOf(['success', 'info', 'warning', 'danger']),
  show: _propTypes["default"].bool,
  delay: _propTypes["default"].number,
  children: _propTypes["default"].node,
  onHideSnackbar: _propTypes["default"].func.isRequired
};
var _default = SnackBar;
exports["default"] = _default;